import { KeyValue } from '@angular/common';
import { map, Observable } from 'rxjs';

export function asyncFilterOptionsFn<T>(
  observable: Observable<T>,
  keyValueTransformer?: (item: T) => KeyValue<string, string>[]
): Observable<KeyValue<string, string>[]> {
  if (keyValueTransformer) {
    return observable.pipe(map(keyValueTransformer));
  }
  return observable as Observable<KeyValue<string, string>[]>;
}
